// extracted by mini-css-extract-plugin
export default {"summary":"ServiceCommissionField_summary__zuLDl","summaryText":"ServiceCommissionField_summaryText__TMGQ7","label":"ServiceCommissionField_label__C+93B"};